import styled from "styled-components";

export const AssetWrapper = styled.div`
  margin-top: 105px;
  padding-bottom: 55px;

  *,
  *::before,
  *::after {
    word-break: keep-all;
  }

  // 공통
  .mo-block {
    display: none;
  }

  .mo-none {
    display: block;
  }

  .figure {
    position: absolute;
    right: -300px;
    top: 0;
    z-index: -1;
    transition: 3s;
  }

  .figure:nth-of-type(2) {
    top: 400px;
    left: -100px;
    width: 600px;
    height: 600px;
  }

  .figure div {
    position: relative;
    width: 600px;
    height: 600px;
    border: 1px dashed #ffbc00;
    box-sizing: border-box;
    border-radius: 50%;
    transition: 3s;
  }

  .figure:nth-of-type(2) div {
    width: 600px;
    height: 600px;
  }

  .figure:nth-of-type(2) div::after {
    content: "";
    position: absolute;
    background: rgba(247, 247, 247, 0.6);
    border-radius: 500px;
    width: 200px;
    height: 200px;
    top: -50px;
    left: 90px;
    z-index: 0;
  }

  .section {
    padding-top: 142px;
  }

  #section-kbAddOneFramework {
    padding-top: 186px;
  }

  #section-kbPms {
    margin-bottom: 100px;
  }

  .section-title {
    margin-bottom: 20px;
    display: block;
    font-family: "KBFG Display";
    font-style: normal;
    font-weight: 600;
    font-size: 36px;
    line-height: 160%;
    color: #000000;

    small {
      display: block;
      font-family: "KBFG Display";
      font-style: normal;
      font-weight: 600;
      margin-bottom: 10px;
      font-size: 20px;
      line-height: 25px;
      color: #ffbc00;
    }
  }

  .content-block {
    font-style: normal;
  }

  .section-desc {
    margin-top: 16px;
    color: #444;
    font-family: "KBFG Display";
    font-size: 20px;
    font-weight: 300;
    line-height: 160%;
    margin-bottom: 36px;
  }

  .section-banner {
    width: 100%;
    height: 400px;
    overflow: hidden;
  }

  .section-banner img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center center;
  }

  .article {
    display: flex;
    align-items: flex-start;
    gap: 0;
    min-width: 0;
    padding: 100px 0;
  }

  .article-title {
    flex-shrink: 0;
    width: 268px;
    color: #000;
    font-family: "KBFG Display";
    font-size: 30px;
    font-weight: 600;
    line-height: 162.5%;
  }

  .article-content {
    flex: 1;
    min-width: 0;
  }

  .article-content .list {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .article-content .item {
  }

  .article-content .item .icon {
    display: block;
    width: 54px;
    margin-bottom: 40px;
  }

  .article-content .item .item-title {
    color: #000;
    font-family: "KBFG Display";
    font-size: 22px;
    font-weight: 600;
    line-height: normal;
    margin-bottom: 16px;
  }

  .article-content .item .item-desc {
    color: #666;
    font-family: "KBFG Text";
    font-size: 16px;
    font-weight: 300;
    line-height: 29px;
  }

  .article-content .item .img {
    display: block;
    width: 100%;
  }

  .article-content .item ul {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-top: 18px;
  }

  .article-content .item ul li {
    width: 100%;
    display: block;
    color: #666;
    font-family: "KBFG Text";
    font-size: 16px;
    font-weight: 300;
    line-height: 29px;
    position: relative;
    padding-left: 12px;
  }

  .article-content .item ul li::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0.8em;
    width: 2px;
    height: 2px;
    border-radius: 50%;
    background-color: #666;
  }

  .article.features {
  }

  .article.functions {
    background-color: #f7f7f7;
    position: relative;
  }

  .article.functions::after {
    content: "";
    position: absolute;
    left: 50%;
    top: 0;
    transform: translateX(-50%);
    width: 100vw;
    max-width: 1798px;
    height: 100%;
    background-color: #f7f7f7;
    z-index: -1;
  }

  .article.features .list,
  .article.functions .list {
    gap: 60px 72px;
  }

  .article.cases .list {
    gap: 24px;
  }

  @media screen and (max-width: 1200px) {
    .article-title {
      width: 240px;
    }
  }

  @media screen and (max-width: 1100px) {
    .article-content .list {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }

  @media screen and (max-width: 1000px) {
    .article-title {
      width: 200px;
    }
  }

  // 모바일
  @media ${(props) => props.theme.mobile} {
    margin-top: 45px;
    padding-bottom: 0;

    // 공통
    .figure {
      display: none;
    }

    .mo-block {
      display: block;
    }

    .mo-none {
      display: none;
    }

    .section {
      padding-top: 90px;
      border-bottom: 20px solid #f3f3f3;
    }

    #section-kbPms {
      margin-bottom: 0;
    }

    #section-kbAddOneFramework {
      padding-top: 90px;
    }

    .section-title {
      font-size: 22px;
      line-height: 140%;
      margin-bottom: 12px;

      small {
        font-size: 16px;
        line-height: normal;
      }
    }

    .section-desc {
      margin-top: 0;
      font-size: 15px;
      margin-bottom: 24px;
    }

    .section-banner {
      height: auto;
      aspect-ratio: 353 / 198;
    }

    .article {
      flex-direction: column;
      gap: 40px;
      padding: 60px 0;
    }

    .article:last-child {
      padding-bottom: 90px;
    }

    .article-title {
      font-size: 20px;
      width: 100%;
    }

    .article-content .list {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .article-content .item .icon {
      margin-bottom: 24px;
    }

    .article-content .item .item-title {
      font-size: 17px;
      margin-bottom: 12px;
    }

    .article-content .item .item-desc {
      font-size: 14px;
      line-height: 23.747px;
    }

    .article-content .item ul {
      margin-top: 12px;
    }

    .article-content .item ul li {
      font-size: 14px;
      padding-left: 10px;
    }

    .article.features .list,
    .article.functions .list {
      gap: 40px 17px;
    }

    .article.cases .list {
      gap: 40px 13px;
    }

    #section-kbPms,
    #section-msp {
      border-bottom: none;
    }
  }
`;

// 상단 배너 섹션
export const Path = styled.div`
  font-family: "KBFG Text";
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 17px;
  color: #ffac00;
  margin-bottom: 32px;
  span {
    font-family: "KBFG Text";
    font-style: normal;
    font-weight: 600;
    font-size: 13px;
    line-height: 17px;
    color: #999999;
    :after {
      content: ">";
      margin: 0 14px;
    }
  }
  @media ${(props) => props.theme.laptop} {
    padding-left: 20px;
  }
  @media ${(props) => props.theme.tablet} {
    font-size: 15px;
    line-height: 19px;
    margin-bottom: 25px;
    padding-left: 0px;
    span {
      font-size: 15px;
      line-height: 19px;
    }
  }
  @media ${(props) => props.theme.mobile} {
    font-size: 13px;
    line-height: 19px;
    margin-bottom: 15px;
    span {
      font-size: 13px;
      line-height: 19px;
    }
  }
`;

export const MainTitle = styled.div`
  margin-bottom: 40px;
  h2 {
    font-family: "KBFG Display";
    font-style: normal;
    font-weight: 700;
    font-size: 50px;
    line-height: 62px;
    color: #1a1a1a;
  }
  @media ${(props) => props.theme.laptop} {
    padding-left: 20px;
  }
  @media ${(props) => props.theme.tablet} {
    margin-bottom: 50px;
    padding-left: 0px;
    h2 {
      font-size: 50px;
      line-height: 72px;
    }
  }
  @media ${(props) => props.theme.mobile} {
    margin-bottom: 20px;
    h2 {
      margin-bottom: 25px;
      font-size: 34px;
      line-height: 35px;
    }
  }
`;

export const MainPost = styled.div`
  width: 100%;
  overflow: hidden;
  height: 420px;
  //height: 520px;
  background-image: url("/asset/top-banner.png");
  background-size: cover;
  background-position: center 37%;
  background-repeat: no-repeat;
  background-attachment: fixed;
  margin-bottom: 0;

  @media ${(props) => props.theme.laptop} {
    background-attachment: scroll;
  }

  @media ${(props) => props.theme.tablet} {
    height: 480px;
    background-position: center center;
  }

  @media ${(props) => props.theme.mobile} {
    height: 215px;
    background-position: center center;
  }
`;
